export default __webpack_public_path__ + "static/s_01-f953d88c545a6ea63e77fa9120b83479.png";